import React from "react";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

const TIMEFRAME_OPTIONS = [
    { value: '7d', label: '7 Days' },
    { value: '31d', label: '1 Month' },
];

const RESOLUTION_OPTIONS = [
    { value: '1h', label: '1 Hour' },
    { value: '1d', label: '1 Day' },
];

const ToolbarGroup = ({ label, value, options, onChange, disabled }) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
            {label}
        </Typography>
        <ToggleButtonGroup
            exclusive
            size="small"
            color="info"
            value={value}
            disabled={disabled}
            onChange={(e, newValue) => {
                if (newValue !== null) onChange(newValue);
            }}
        >
            {options.map(opt => (
                <ToggleButton key={opt.value} value={opt.value} sx={{ textTransform: 'none', px: 2 }}>
                    {opt.label}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    </Box>
);

const BoilerToolbar = ({ plotSpecs, updatePlotSpecs, disabled = false }) => (
    <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-end',
        gap: 3,
        backgroundColor: 'white',
        borderRadius: '10px',
        padding: 1.5,
        width: '100%',
        boxSizing: 'border-box',
        mb: 1,
    }}>
        <ToolbarGroup
            label="Timeframe"
            value={plotSpecs.timeframe}
            options={TIMEFRAME_OPTIONS}
            disabled={disabled}
            onChange={value => updatePlotSpecs({ target: { value } }, 'timeframe')}
        />
        <ToolbarGroup
            label="Resolution"
            value={plotSpecs.resolution}
            options={RESOLUTION_OPTIONS}
            disabled={disabled}
            onChange={value => updatePlotSpecs({ target: { value } }, 'resolution')}
        />
    </Box>
);

export default BoilerToolbar;
